import { useEffect, useState } from "react";
import styles from "../addBooking.module.css";
import { Delete } from "@mui/icons-material";
import { Dialog, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import axios from "axios";
import { isOfferedCategory, withSavedSelections } from "../../../../../utils/savedCatalogueOptions";
import { authData } from "../../../../components/GetAuth";
import { NumericFormat } from "react-number-format";

const ProductComponent = ({ fields, append, errors, control, setValue, register, clearErrors, watch, getValues, cngProductVal, delItems, calculateDimension, disabled = false, freightType }) => {
    const auth = authData();
    const API_TOKEN = auth?.api_token;
    const [productList, setProductList] = useState([]);
    // Saved bookings keep their category/item even if it's no longer offered
    const productOptions = withSavedSelections(productList, watch("products"));

    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + "v1/product-dd-list", {
            headers: {
                Authorization: `Bearer ${API_TOKEN}`
            }
        }).then((response) => {
            if (response.data.status === "SUCCESS") {
                let allData = response.data.data;
                allData = allData.concat([{ id: 0, title: 'Other' }, { id: -1, title: 'Other With Dimension' }]);
                setProductList(allData);
            }
        });
    }, [API_TOKEN]);

    const [bulkAddOpen, setBulkAddOpen] = useState(false);
    const [bulkAddCount, setBulkAddCount] = useState("2");

    const openBulkAdd = () => {
        setBulkAddCount("2");
        setBulkAddOpen(true);
    };

    const confirmBulkAdd = () => {
        const count = parseInt(bulkAddCount, 10);
        if (!count || count < 1) return;

        const products = getValues("products");
        const lastItem = products?.[products.length - 1];

        if (!lastItem) {
            setBulkAddOpen(false);
            return;
        }

        const newItems = Array.from({ length: count }, () => ({ ...lastItem }));
        append(newItems);

        cngProductVal();
        setBulkAddOpen(false);
    }

    return (<div className={`${styles.BookADelivery}`}>
        <div className={`${styles.BookADeliveryCardArea}`}>
            {fields?.map((item, index) => {
                return (<div className={`${styles.BookDeliveryCard}`} key={item.id}>
                    <div className={`${styles.BookDeliveryCardUnder}`}>
                        <div className={`${styles.BookDeliveryCardUnderRow}`}>

                            <div className={styles.ProductField}>
                                <FormControl fullWidth>
                                    <InputLabel>Category*</InputLabel>
                                    <Controller
                                        key={item.id}
                                        control={control}
                                        {...register(`products[${index}].category_id`, { required: true })}
                                        render={({ field }) => (<Select
                                            {...field}
                                            disabled={disabled}
                                            label="Category*"
                                            onChange={(e) => {
                                                field.onChange(e);
                                                if (e.target.value) {
                                                    if (e.target.value === -1) {
                                                        setValue(`products[${index}].item_id`, 0);
                                                    } else {
                                                        let selCat = productOptions?.filter((i) => i?.id === e.target.value);
                                                        if (selCat.length) {
                                                            selCat = selCat[0];
                                                            setValue(`products[${index}].item_id`, "");
                                                            setValue(`products[${index}].item_name`, "");
                                                            setValue(`products[${index}].total`, "");
                                                            setValue(`products[${index}].estimated_value`, "");
                                                            setValue(`products[${index}].is_item`, true);
                                                            clearErrors();
                                                        }
                                                        cngProductVal();
                                                    }
                                                } else {
                                                    setValue(`products[${index}].item_id`, 0);
                                                }
                                            }}
                                        >
                                            {productOptions?.map((val) => {
                                                return (isOfferedCategory(productOptions, val) || val?.id === 0 || val?.id === -1) ? (<MenuItem key={val?.id} value={val?.id}>{val?.title}</MenuItem>) : null;
                                            })}
                                        </Select>)}
                                    />
                                </FormControl>
                                {errors?.products?.length > 0 && errors?.products[index]?.category_id && (<p className={`${styles.ErrorM}`}>Please select category</p>)}
                            </div>

                            <div className={styles.ProductField}>
                                {(watch(`products[${index}].category_id`) === 0 || watch(`products[${index}].category_id`) === -1) && (<>
                                    <Controller
                                        key={item.id}
                                        control={control}
                                        {...register(`products[${index}].item_name`, { required: true })}
                                        render={({ field }) => (<TextField
                                            {...field}
                                            fullWidth
                                            disabled={disabled}
                                            label="Product*"
                                            variant="outlined"
                                            onChange={(e) => {
                                                field.onChange(e);
                                            }}
                                        />)}
                                    />
                                    {errors?.products?.length > 0 && errors?.products[index]?.item_name && (<p className={`${styles.ErrorM}`}>Please select item</p>)}
                                </>)}
                                {(watch(`products[${index}].is_item`) && watch(`products[${index}].category_id`) !== 0 && watch(`products[${index}].category_id`) !== -1) && (<>
                                    <FormControl fullWidth>
                                        <InputLabel>Item*</InputLabel>
                                        <Controller
                                            key={item.id}
                                            control={control}
                                            {...register(`products[${index}].item_id`, { required: true })}
                                            render={({ field }) => (<Select
                                                {...field}
                                                disabled={disabled}
                                                label="Item*"
                                                onChange={(e) => {
                                                    field.onChange(e);
                                                    if (e.target.value) {
                                                        let selProduct = productOptions?.filter((i) => i?.id === e.target.value);
                                                        if (selProduct.length) {
                                                            selProduct = selProduct[0];
                                                            setValue(`products[${index}].item_name`, selProduct?.parent?.title + "- " + selProduct?.title);
                                                            setValue(`products[${index}].total`, selProduct?.amount);
                                                            setValue(`products[${index}].estimated_value`, selProduct?.amount);
                                                            clearErrors();
                                                        }
                                                    }
                                                    cngProductVal();
                                                }}
                                            >
                                                {productOptions?.map((val) => {
                                                    return val?.parent_id === watch(`products[${index}].category_id`) ? (<MenuItem key={val?.id} value={val?.id}>{val?.title}</MenuItem>) : null;
                                                })}
                                            </Select>)}
                                        />
                                    </FormControl>
                                    {errors?.products?.length > 0 && errors?.products[index]?.item_id && (<p className={`${styles.ErrorM}`}>Please select item</p>)}
                                </>)}
                            </div>

                            {watch(`products[${index}].category_id`) === -1 && <>
                                <div className={styles.ProductFieldDim}>
                                    <Controller
                                        key={item.id}
                                        control={control}
                                        {...register(`products[${index}].length`, { required: true })}
                                        render={({ field }) => (<NumericFormat
                                            {...field}
                                            fullWidth
                                            disabled={disabled}
                                            label="Length(cm)*"
                                            variant="outlined"
                                            customInput={TextField}
                                            allowLeadingZeros={false}
                                            allowNegative={false}
                                            decimalScale={2}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                calculateDimension(index);
                                            }}
                                        />)}
                                    />
                                    {errors?.products?.length > 0 && errors?.products[index]?.length && (<p className={`${styles.ErrorM}`}>Please enter length</p>)}
                                </div>
                                <div className={styles.ProductFieldDim}>
                                    <Controller
                                        key={item.id}
                                        control={control}
                                        {...register(`products[${index}].width`, { required: true })}
                                        render={({ field }) => (<NumericFormat
                                            {...field}
                                            fullWidth
                                            disabled={disabled}
                                            label="Width(cm)*"
                                            variant="outlined"
                                            customInput={TextField}
                                            allowLeadingZeros={false}
                                            allowNegative={false}
                                            decimalScale={2}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                calculateDimension(index);
                                            }}
                                        />)}
                                    />
                                    {errors?.products?.length > 0 && errors?.products[index]?.width && (<p className={`${styles.ErrorM}`}>Please enter width</p>)}
                                </div>
                                <div className={styles.ProductFieldDim}>
                                    <Controller
                                        key={item.id}
                                        control={control}
                                        {...register(`products[${index}].height`, { required: true })}
                                        render={({ field }) => (<NumericFormat
                                            {...field}
                                            fullWidth
                                            disabled={disabled}
                                            label="Height(cm)*"
                                            variant="outlined"
                                            customInput={TextField}
                                            allowLeadingZeros={false}
                                            allowNegative={false}
                                            decimalScale={2}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                calculateDimension(index);
                                            }}
                                        />)}
                                    />
                                    {errors?.products?.length > 0 && errors?.products[index]?.height && (<p className={`${styles.ErrorM}`}>Please enter height</p>)}
                                </div>
                            </>}

                            {freightType === 'Air Freight' && (
                                <div className={styles.ProductFieldDim}>
                                    <Controller
                                        key={item.id}
                                        control={control}
                                        {...register(`products[${index}].weight`, { required: true })}
                                        render={({ field }) => (<NumericFormat
                                            {...field}
                                            fullWidth
                                            disabled={disabled}
                                            label="Weight(kg)*"
                                            variant="outlined"
                                            customInput={TextField}
                                            allowLeadingZeros={false}
                                            allowNegative={false}
                                            decimalScale={2}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                cngProductVal();
                                            }}
                                        />)}
                                    />
                                    {errors?.products?.length > 0 && errors?.products[index]?.weight && (<p className={`${styles.ErrorM}`}>Please enter weight</p>)}
                                </div>
                            )}

                            <div className={styles.ProductFieldTotal}>
                                <Controller
                                    key={item.id}
                                    control={control}
                                    {...register(`products[${index}].estimated_value`, { required: true })}
                                    render={({ field }) => (<NumericFormat
                                        {...field}
                                        fullWidth
                                        label="Estimated Value*"
                                        variant="outlined"
                                        customInput={TextField}
                                        allowLeadingZeros={false}
                                        allowNegative={false}
                                        decimalScale={2}
                                        fixedDecimalScale
                                    />)}
                                />
                                {errors?.products?.length > 0 && errors?.products[index]?.estimated_value && (<p className={`${styles.ErrorM}`}>Please enter estimated value</p>)}
                            </div>

                            <div className={styles.ProductFieldTotal}>
                                <Controller
                                    key={item.id}
                                    control={control}
                                    {...register(`products[${index}].total`, { required: true })}
                                    render={({ field }) => (<NumericFormat
                                        {...field}
                                        fullWidth
                                        disabled={disabled}
                                        label="Total*"
                                        variant="outlined"
                                        customInput={TextField}
                                        allowLeadingZeros={false}
                                        allowNegative={false}
                                        decimalScale={2}
                                        fixedDecimalScale
                                        onChange={(e) => {
                                            field.onChange(e);
                                            cngProductVal();
                                        }}
                                    />)}
                                />
                                {errors?.products?.length > 0 && errors?.products[index]?.total && (<p className={`${styles.ErrorM}`}>Please enter total amount</p>)}
                            </div>

                        </div>
                    </div>

                    <button className={`${styles.CardTrashBU}`} type="button" disabled={disabled} onClick={(e) => { delItems(index); }}><Delete /></button>
                </div>);
            })}

            <button className={`${styles.HomeBU}`} type="button" disabled={disabled} onClick={() => { append({ category_id: "", item_id: "", item_name: "", total: "", estimated_value: "", is_item: true, weight: "" }); }}>Add Items</button>

            <button className={`${styles.HomeBUOutline}`} type="button" disabled={disabled} onClick={openBulkAdd}>Add Multiple Items</button>
        </div>

        <Dialog open={bulkAddOpen} onClose={() => setBulkAddOpen(false)} maxWidth="xs" fullWidth>
            <div className={styles.BulkAddModal}>
                <h3 className={styles.BulkAddTitle}>Add Multiple Items</h3>
                <p className={styles.BulkAddSub}>
                    This will copy the details of the last item (category, price, dimensions, etc.) into the quantity you enter below.
                </p>

                <TextField
                    className={styles.BulkAddField}
                    type="number"
                    fullWidth
                    autoFocus
                    label="Quantity"
                    value={bulkAddCount}
                    onChange={(e) => {
                        const val = e.target.value;
                        if (val === "" || (/^\d+$/.test(val) && parseInt(val, 10) <= 999)) {
                            setBulkAddCount(val);
                        }
                    }}
                    inputProps={{ min: 1, max: 999 }}
                />

                <div className={styles.BulkAddActions}>
                    <button
                        type="button"
                        className={styles.BulkAddCancelBU}
                        onClick={() => setBulkAddOpen(false)}
                    >
                        Cancel
                    </button>

                    <button
                        type="button"
                        className={styles.BulkAddConfirmBU}
                        disabled={!bulkAddCount || parseInt(bulkAddCount, 10) < 1}
                        onClick={confirmBulkAdd}
                    >
                        Add {bulkAddCount || ''} Items
                    </button>
                </div>
            </div>
        </Dialog>
    </div >);
}

export default ProductComponent;